import { enStatus } from 'interface/course';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core';

import { CourseTheme } from 'assets/themes/Course';
import { useAppSelector } from 'hooks/redux';

const useStyles = makeStyles<CourseTheme>((theme) => ({
  root: {
    '& h3': {
      '@media (max-width: 1024px)': {
        fontSize: 16,
      },
      '@media (max-width: 425px)': {
        textAlign: 'justify',
      },
      color: theme.variables.courseTheme.text,
    },
    '& button': {
      textTransform: 'capitalize',
      color: theme.variables.courseTheme.text,
      minWidth: 'fit-content',
      fontWeight: 600,
      fontSize: 16,
      '@media (max-width: 1024px)': {
        fontSize: 14,
      },
    },
    margin: theme.spacing(4, 0),
    display: 'flex',
    borderRadius: 8,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing(6),
    background: theme.variables.courseTheme.cardBackground,
  },
}));

const Authenticated = () => {
  const classes = useStyles();
  const history = useHistory();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const courseStatus = useAppSelector((state) => state.course.status);
  const courseHash = useAppSelector((state) => state.course.hash);

  const openAccounts = () => {
    history.push(`/cadastro/${courseHash}`);
  };

  if (isAuthenticated || courseStatus === enStatus.FREE) {
    return null;
  }

  return (
    <div className={classes.root}>
      <Typography variant='h3'>Ops! Parece que você não está logado.</Typography>
      <Button variant='contained' color='primary' onClick={openAccounts}>
        Iniciar sessão
      </Button>
    </div>
  );
};

export default Authenticated;
